var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSustainableBusinessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2843",
    "data-name": "Group 2843",
    transform: "translate(-8808 -2724)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(8808 2724)",
    fill: "#1b62ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2880",
    "data-name": "Group 2880",
    transform: "translate(8720.999 2701.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M329.954,161.546a12.653,12.653,0,0,1-3.791,7.577,10.677,10.677,0,0,1-7.372,2.7c.007-.123.011-.252.011-.391a7.249,7.249,0,0,0-.087-1.09,6.628,6.628,0,0,0-.159-.732,7,7,0,0,1,1.3-1.53c1.062-.951,2.3-1.654,3.441-2.509-1.271.735-2.6,1.363-3.807,2.208a9.459,9.459,0,0,0-1.224,1.01,5.776,5.776,0,0,0-.9-1.447c-.094-.109-.193-.215-.3-.32.126-.3.264-.6.412-.889a9.013,9.013,0,0,1,3.652-3.486c1.607-.924,3.345-1.573,5.018-2.355,1.516-.71,3.05-1.723,3.2-3.544a7.819,7.819,0,0,1,.607,4.8Z",
    transform: "translate(-202.547 -113.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M200.732,239.967c-1.014-2.161-3.731-2.088-7.945-4.14s-2.982-10.231-3.012-9.955c-.073.681,2.9,2.439,6.67,3.775a6.453,6.453,0,0,1,2.813,1.837,5.39,5.39,0,0,1,.927,1.54,6.122,6.122,0,0,1,.343,1.278,6.883,6.883,0,0,1,.081,1.036,6.151,6.151,0,0,1-.123,1.313,12.97,12.97,0,0,0-1.151-1.358,9.5,9.5,0,0,0-3.363-2.333,3.027,3.027,0,0,0-.416-.129c-.044-.008-.067-.009-.053,0,.162.1.317.2.469.294a13.5,13.5,0,0,1,2.563,2.114c.241.258.462.516.654.765,1.728,2.253,1.6,4.091,1.542,3.961Z",
    transform: "translate(-84.72 -177.837)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M113.207,35.1l-1.576,2.736-1.831.492,1.089-1.889A16.888,16.888,0,0,0,99.9,56.851l-1.272.343a18.2,18.2,0,0,1,11.984-22.041l-1.968-1.134,1.831-.493Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M413.081,71.688l-.491,1.831L409.856,75.1l-1.579-2.735.491-1.832,1.09,1.89a16.925,16.925,0,0,0-12.182-19.728l.342-1.273a18.243,18.243,0,0,1,13.1,21.4Z",
    transform: "translate(-277.081 -16.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M186.507,436.241a18.3,18.3,0,0,1-12.914,5.334,18.122,18.122,0,0,1-12.166-4.693l0,2.271-1.339-1.344,0-3.158,3.158,0L164.588,436l-2.18,0a16.883,16.883,0,0,0,23.17-.686Z",
    transform: "translate(-57.404 -370.882)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainableBusinessIcon);
export default __webpack_public_path__ + "static/media/sustainable-business-icon.7e4a2423.svg";
export { ForwardRef as ReactComponent };